import React, { Component } from 'react';
import styles from './Home.module.css';
import axios from 'axios';
import Movie from '../../movie/Movie';

export class home extends Component {
  constructor(){
    super();
    this.state = {
      products: [],
    }
  }
  componentDidMount() {
    axios
      .get("https://www.omdbapi.com/?apikey=45f0782a&s=war")
      .then((response) => {
        // console.log(response);
        this.setState({
          products: response.data.Search,
        });
      })
      .catch((err) => {});
  }
  render() {
    return (
      <div className={styles.container}>
        {/* {console.log(this.state.products)} */}
        <div className={styles.movies}>
          {this.state.products.map((product) => { 
           return (
              <Movie image={product.Poster} title={product.Title}/>
           )
            })}
        </div>
      </div>
    )
  }
}

export default home